import React from 'react';
import PropTypes from 'prop-types';
import { i18n, formatNumber, formatDate } from '../../Utility/Format';

import CurrencyPairLink from '../Helper/CurrencyPairLink';
import CurrencyTable, { CurrencyTableColumnsGroup, scrollableCellStyle } from '../Tables/CurrencyTable';


/*const getFixedRows = (rows, currencyPairsWithFootnotes) => {
    return {
        headerRow: (
            <tr>
                <th>{i18n('dbm.currency.ccyPair')}</th>
            </tr>
        ),
        contentRows: (
            rows.map((row) => {
                return (
                    <tr key={row.ccyPair}>
                        <td>
                            <CurrencyPairLink currencyPair={row.ccyPair} labelAddition={currencyPairsWithFootnotes.indexOf(row.ccyPair) >= 0 ? '*' : null} />
                        </td>
                    </tr>
                )
            })
        )
    };
};*/

const getOtherRows = (rows,currencyPairsWithFootnotes, locale) => {
    const numberOfScrollableCells = 6;
    const numberOfDecimals = 4;
    

    return {
        headerRow: (
            <tr>
                <th style={{textAlign:'left'}}>{i18n('dbm.currency.ccyPair')}</th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.clientBid')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.traderBid')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.traderAsk')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.clientAsk')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.currency.bidDifference')}
                </th>
                <th style={scrollableCellStyle(numberOfScrollableCells)}>
                    {i18n('dbm.valueDate')}
                </th>
            </tr>
        ),
        contentRows: (
            rows.map((row) => {
                return (
                    <tr key={row.ccyPair}>
                          <td style={{textAlign:'left'}}>
                            <CurrencyPairLink currencyPair={row.ccyPair} labelAddition={currencyPairsWithFootnotes.indexOf(row.ccyPair) >= 0 ? '*' : null} />
                        </td>
                        <td>
                            {row.clientBid ? formatNumber(row.clientBid, numberOfDecimals) : "-"}
                        </td>
                        <td>
                            {row.traderBid ? formatNumber(row.traderBid, numberOfDecimals) : "-"}
                        </td>
                        <td>
                            {row.traderAsk ? formatNumber(row.traderAsk, numberOfDecimals) : "-"}
                        </td>
                        <td>
                            {row.clientAsk ? formatNumber(row.clientAsk, numberOfDecimals) : "-"}
                        </td>
                        <td>
                            {row.bidDifference ? formatNumber(row.bidDifference, numberOfDecimals) : "-"}
                        </td>
                        <td>
                            {row.valueDate ? formatDate(row.valueDate, locale) : "-"}
                        </td>
                    </tr>
                )
            })
        )
    };
};

/**
 * SettlementTable
 */
const SettlementTable = (props) => {

   //const fixedRows = getFixedRows(props.rows, props.currencyPairsWithFootnotes);
    const otherRows = getOtherRows(props.rows,props.currencyPairsWithFootnotes, props.locale);

    return(
        <CurrencyTable>
          {/*<CurrencyTableColumnsGroup
                isFixed={true}
                headerRow={fixedRows.headerRow}
                contentRows={fixedRows.contentRows}
    />  */}  
            <CurrencyTableColumnsGroup
                headerRow={otherRows.headerRow}
                contentRows={otherRows.contentRows}
            />
        </CurrencyTable>
    );
};

SettlementTable.propTypes = {
    currencyPairsWithFootnotes: PropTypes.array.isRequired,
    rows: PropTypes.arrayOf(
        PropTypes.shape({
            clientBid: PropTypes.number,
            clientAsk: PropTypes.number,
            traderBid: PropTypes.number,
            traderAsk: PropTypes.number,
            bidDifference: PropTypes.number,
            valueDate: PropTypes.string
        })
    ),
    locale: PropTypes.string
};

export default SettlementTable;